import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DeliveryModel} from '@pages/delivery/_models/delivery.model';
import {MeasurementUnitModel} from '@common/_models/measurement-unit.model';
import {of, Subscription, throwError} from 'rxjs';
import {ModalController} from '@ionic/angular';
import {DeliveryService} from '@pages/delivery/_services';
import {TypesUtilsService} from '@core/utils/types-utils.service';
import {MessageType, NotificationService} from '@core/_services/notification/notification.service';
import {catchError, first} from 'rxjs/operators';
import {ChecklistComponent} from '@core/components/checklist/checklist.component';
import {NewDeliveryReturnModalPage} from '@pages/delivery/components/new-delivery-return-modal/new-delivery-return-modal.page';
import {DetailDeliveryReturnModalPage} from '@pages/delivery/components/detail-delivery-return-modal/detail-delivery-return-modal.page';

@Component({
  selector: 'app-detail-delivery-client-modal',
  templateUrl: './detail-delivery-client-modal.page.html',
  styleUrls: ['./detail-delivery-client-modal.page.scss'],
})
export class DetailDeliveryClientModalPage implements OnInit, OnDestroy {

  id: number;
  isLoading$;
  delivery: DeliveryModel;
  updated = false;
  checklist:boolean = false;
  reDelivery: boolean = true;
  realDelivery: boolean = true;

  private subscriptions: Subscription[] = [];


  constructor(
      private modalController: ModalController,
      private deliveryService: DeliveryService,
      public typesUtils: TypesUtilsService,
      private notificationService: NotificationService
  ) {
  }

  ngOnInit() {
    this.isLoading$ = this.deliveryService.isLoading$;
    this.loadDelivery();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  loadDelivery() {
    if (!this.id) {
      this.delivery = new DeliveryModel();
    } else {
      const sb = this.deliveryService.getItemById(this.id).pipe(
          first(),
          catchError(async (errorMessage) => {
            console.log(errorMessage);
            this.notificationService.showActionNotification('COMMON.DATA_SERVER_ERROR', MessageType.Error);
            await this.modalController.dismiss(false);
            return throwError(errorMessage);
          })
      ).subscribe((delivery: DeliveryModel) => {
        this.delivery = DeliveryModel.jsonToModel(delivery);
      });
      this.subscriptions.push(sb);
    }
  }

  async closeModal() {
    await this.modalController.dismiss(this.updated);
  }

  doChecklist(){
    this.editChecklist();

  }

  getAllergenByProvider(reception_item) {
    const provideIndex = reception_item.raw_material.providers.findIndex((item) => item.id ===  reception_item.provider.id);
    if (provideIndex >= 0) {
      return reception_item.raw_material.providers[provideIndex].homologate;
    }
    return null;
  }

  getHomologateByProvider(reception_item) {
    const provideIndex = reception_item.raw_material.providers.findIndex((item) => item.id ===  reception_item.provider.id);
    if (provideIndex >= 0) {
      return reception_item.raw_material.providers[provideIndex].homologate;
    }
    return null;
  }

  async editChecklist() {
    const modal = await this.modalController.create({
      component: ChecklistComponent,
      backdropDismiss: false,
      componentProps: {
        idChecklist: 3,
        idResultChecklist: this.delivery.checklist_id,
        entity: "DELIVERY",
        entity_id: this.delivery.id,
        action:'detail',
        uploadType: 'file'

      },
      cssClass: 'right-side-modal-css',
    });

    modal.onDidDismiss().then((response) => {
      if(response.data) {
        this.updated = true;
        this.closeModal();
      }

    });

    return await modal.present();
  }

  async openNewReturn() {
    const modal = await this.modalController.create({
      component: NewDeliveryReturnModalPage,
      backdropDismiss: false,
      cssClass: 'right-side-modal-css',
      componentProps: {
        deliveryId: this.delivery.id
      }
    });

    modal.onDidDismiss().then((response) => {
      if (response.data) {
        this.updated = true;
        this.loadDelivery();
      }
    });

    return await modal.present();
  }

  async openDetailReturn(id) {
    const modal = await this.modalController.create({
      component: DetailDeliveryReturnModalPage,
      backdropDismiss: false,
      cssClass: 'right-side-modal-css',
      componentProps: {
        id: id
      }
    });

    return await modal.present();
  }
}
